import Component, { getWidgetGeneratorServerSideProps } from 'page-components/global/widget';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Component;
export const getServerSideProps = propsWithI18NSSR(getWidgetGeneratorServerSideProps);
